var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sparkle",
    clipPath: "url(#clip0_0_985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.84026 0.556883C2.79538 0.59416 2.76494 0.645961 2.75423 0.703315L2.49146 2.09293C2.4728 2.19172 2.42478 2.2826 2.35369 2.35369C2.2826 2.42478 2.19172 2.4728 2.09293 2.49146L0.703315 2.75423C0.645961 2.76494 0.59416 2.79538 0.556883 2.84026C0.519606 2.88515 0.4992 2.94165 0.4992 3C0.4992 3.05835 0.519606 3.11485 0.556883 3.15974C0.59416 3.20462 0.645961 3.23506 0.703315 3.24577L2.09293 3.50854C2.19172 3.5272 2.2826 3.57522 2.35369 3.64631C2.42478 3.7174 2.4728 3.80828 2.49146 3.90707L2.75423 5.29669C2.76494 5.35404 2.79538 5.40584 2.84026 5.44312C2.88515 5.48039 2.94165 5.5008 3 5.5008C3.05835 5.5008 3.11485 5.48039 3.15974 5.44312C3.20462 5.40584 3.23506 5.35404 3.24577 5.29669L3.50854 3.90707C3.5272 3.80828 3.57522 3.7174 3.64631 3.64631C3.7174 3.57522 3.80828 3.5272 3.90707 3.50854L5.29669 3.24577C5.35404 3.23506 5.40584 3.20462 5.44312 3.15974C5.48039 3.11485 5.5008 3.05835 5.5008 3C5.5008 2.94165 5.48039 2.88515 5.44312 2.84026C5.40584 2.79538 5.35404 2.76494 5.29669 2.75423L3.90707 2.49146C3.80828 2.4728 3.7174 2.42478 3.64631 2.35369C3.57522 2.2826 3.5272 2.19172 3.50854 2.09293L3.24577 0.703315C3.23506 0.645961 3.20462 0.59416 3.15974 0.556883C3.11485 0.519606 3.05835 0.4992 3 0.4992C2.94165 0.4992 2.88515 0.519606 2.84026 0.556883Z",
    stroke: "#6E6E6E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle4);
export default __webpack_public_path__ + "static/media/sparkle-4.3af8fea22d95dc019f4002fb0a285b5d.svg";
export { ForwardRef as ReactComponent };